export default "__VITE_ASSET__fa96c5f4__"